import React, { useState } from "react";
import { useFlutterwave, closePaymentModal } from "flutterwave-react-v3";
import { ApiRequest } from "../config/ApiService";

import Logo from "../imgs/logo.svg";
import toast from "react-hot-toast";

const SupportForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [amount, setAmount] = useState("");
  const [anonymous, setAnonymous] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showAlt, setShowAlt] = useState(false);

  const config = {
    public_key: "FLWPUBK-9240b5017e8dc50e404271b4113c3ae3-X",
    tx_ref: Date.now(),
    amount: Number(amount),
    currency: "NGN",
    payment_options: "card,mobilemoney,ussd",
    customer: {
      email: email,
    },
    customizations: {
      title: "Patron Donation",
      description: "Donation to Hallimo",
      logo: "https://res.cloudinary.com/dxzlhtdr0/image/upload/v1736841676/logo_dzjrgk.svg",
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    handleFlutterPayment({
      callback: (response) => {
        handlePayment(response);
      },
      onClose: () => {
        setSubmitting(false);
      },
    });
  };

  const handlePayment = async (response) => {
    try {
      let req = await ApiRequest({
        url: "transactions",
        method: "post",
        data: {
          name: name ? name : "Anonymous",
          email: email,
          amount: Number(amount),
          transaction_id: String(response.transaction_id),
          reference: String(response.tx_ref),
          provider: "Flutterwave",
          status: "success",
          is_anonymous: anonymous,
        },
      });

      closePaymentModal(); // this will close the modal programmatically

      if (req.status == "success") {
        setSubmitting(false);
        toast.success(req.message);

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        setSubmitting(false);
        toast.error(req.message);
      }
    } catch (error) {
      closePaymentModal(); // this will close the modal programmatically
      setSubmitting(false);
    }
  };

  return (
    <div
      id="support-form"
      className="flex items-center justify-center bg-white px-4 md:px-0"
    >
      <div className="w-full max-w-md p-8 space-y-4 bg-white rounded-md my-4 border border-[#586A78]">
        <img
          src={Logo}
          height={40}
          width={40}
          className="place-self-center mb-10"
        />
        <h2 className="text-2xl text-black">Support Hallimo Today</h2>

        <form onSubmit={handleSubmit} className="space-y-4 pt-3">
          <div>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 text-sm border-1.5 border-black rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Full Name / Organization"
              required={anonymous ? false : true}
            />
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              id="anonymous"
              checked={anonymous}
              onChange={(e) => setAnonymous(e.target.checked)}
              className="w-4 h-4 text-blue-500 border-gray-300 rounded focus:ring-blue-500"
            />
            <label htmlFor="anonymous" className="ml-2 text-sm text-gray-700">
              Stay Anonymous
            </label>
          </div>

          <div>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 text-sm border-1.5 border-black rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Email Address"
              required
            />
          </div>

          <div>
            <select
              id="amount"
              value={amount}
              onChange={(e) => {
                if (e.target.value == "100000") {
                  setAmount(e.target.value);
                  setShowAlt(true);
                } else {
                  setAmount(e.target.value);
                }
              }}
              className="w-full px-4 py-3 text-sm border-1.5 border-black rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required={showAlt ? false : true}
            >
              <option value="">Select Amount</option>
              <option value="10000">₦10,000</option>
              <option value="50000">₦50,000</option>
              <option value="250000">₦250,000</option>
              <option value="500000">₦500,000</option>
              <option value="100000">₦1m - ₦5m</option>
            </select>
          </div>

          {showAlt && (
            <div>
              <input
                type="number"
                id="amountAlt"
                value={Number(amount)}
                onChange={(e) => setAmount(e.target.value)}
                className="w-full px-4 py-3 text-sm border-1.5 border-black rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Amount"
                required={showAlt}
                min="1000000"
                max="5000000"
              />
            </div>
          )}

          <button
            type="submit"
            disabled={submitting ? true : false}
            className="w-full px-4 py-2 border-1.5 border-[#052035] text-[#052035] bg-[#3bf5ca] rounded-lg focus:ring-2 focus:ring-[#3BF5CA] focus:ring-offset-2"
          >
            {submitting ? "Please wait..." : "Donate"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SupportForm;
